import React from 'react'
import { Observable } from 'rxjs'
import { AjaxResponse } from 'rxjs/ajax'
import { getAccountBalances } from 'utils/api-routes-accounts'
import ReportTablePage from './ReportTablePage'
import { useFinanceObservable } from '../../hooks/useFinanceObservable'

import { FinanceApiResponse } from '../../types/finance'

const AccountBalances = () => {
  const report = useFinanceObservable<Record<string, any>[]>(
    () =>
      getAccountBalances({}) as any as Observable<
        AjaxResponse<FinanceApiResponse<Record<string, any>[]>>
      >,
  )

  return (
    <ReportTablePage
      title="Account Balances"
      rows={report.data || []}
      isLoading={report.loading}
      columns={[
        {
          name: 'Code',
          selector: (row) => (row.account_code as string) || '--',
        },
        {
          name: 'Account',
          selector: (row) => (row.account_name as string) || '--',
        },
        {
          name: 'Classification',
          selector: (row) => (row.classification as string) || '--',
        },
        { name: 'Balance', selector: (row) => (row.balance as number) || 0 },
      ]}
    />
  )
}

export default AccountBalances
